<template>
  <div>
    <baidu-map :center="center" :zoom="zoom" @ready="handler" class="bm-view">
      <!-- <bm-marker :position="{lng: 121.409682, lat: 29.857152}" :dragging="false" > -->
      <!-- </bm-marker> -->
    </baidu-map>
    <div class="info_div">
      <p class="title margin_top">{{ language == 'zh' ? data.name : data.nameEn }}</p>
      <p class="margin_top"> {{ language == 'zh' ? '地址：' + data.address : 'Add.:' + data.addressEn }}</p>
      <p>{{ language == 'zh' ? '邮编：' : 'Postcode:' }} {{ data.code }}</p>
      <p class="margin_top">{{ language == 'zh' ? '咨询产品' : 'About Products' }}</p>
      <p>{{ language == 'zh' ? '电话：' : 'Tel:' }} {{ data.tel }}</p>
      <p>{{ language == 'zh' ? '邮箱：' : 'Email:' }} {{ data.email }}</p>
      <p class="margin_top">{{ language == 'zh' ? '其他合作' : 'Others' }}</p>
      <p>{{ language == 'zh' ? '电话：' : 'Tel:' }} {{ data.otherTel }}</p>
      <p>{{ language == 'zh' ? '邮箱：' : 'Email:' }} {{ data.otherEmail }}</p>
      <p>{{ language == 'zh' ? '客服：' : 'Customer:' }} {{ data.otherTel2 }}</p>
      <p class="margin_top">{{ language == 'zh' ? '关注我们' : 'Follow us' }}</p>
      <div class="flex_div">
        <div v-for="item in SocialList">
          <div
            v-if="item.name=='公众号'"
          >

            <el-popover
              placement="top"
              width="150"
              transition="none"
              close-delay="0"
              trigger="hover"
            >
              <img :src="item.url" class="img_div2">
              <div class="img_div" slot="reference">
                <img :src="item.img"/>
              </div>
            </el-popover>
          </div>
          <div class="img_div" v-else
               @click="jumpTo(language == 'zh' ? item.url:item.nameEn)">
            <img :src="item.img"/>
          </div>
        </div>
        <!--        <div class="img_div">-->
        <!--          <img :src="data.pic1"/>-->
        <!--          <p v-html="language == 'zh' ? '客服微信' : 'Wechat<br/>Customer Service'"></p>-->
        <!--        </div>-->
        <!--        <div class="img_div">-->
        <!--          <img  :src="data.pic2"/>-->
        <!--          <p v-html="language == 'zh' ? '公众号' : 'Wechat<br/>Official Account'"></p>-->
        <!--        </div>-->
        <!--        <div class="img_div">-->
        <!--          <img   :src="data.pic3"/>-->
        <!--          <p v-html="language == 'zh' ? '抖音号' : 'Tik Tok<br/>Official Account'"></p>-->
        <!--        </div>-->
      </div>
      <el-button
        type="primary"
        class="infoBtn"
        @click="showInfoDialog"
      >{{ language == "zh" ? "立即询价" : "Request for quotation" }}
      </el-button>
    </div>
    <AskDialog ref="AskDialog" :language="language"></AskDialog>
  </div>
</template>
<script>
import AskDialog from "../AskDialog.vue";

export default {
  components: {AskDialog},
  props: {
    language: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      center: {lng: 0, lat: 0},
      zoom: 15,
      data: {},
      lng: 121.791181,
      lat: 29.912295,
      SocialList: [],
    };
  },
  mounted() {
    this.getInfo();
    this.getSocialMsg();
  },
  methods: {
    jumpTo(url) {
      window.open(url, "_blank");
    },
    showInfoDialog() {
      this.$refs.AskDialog.init();
    },
    getSocialMsg() {
      this.$http.get("hdbs/api/social/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.SocialList = response.data.page.list;
          }
        }.bind(this)
      );
    },
    handler({BMap, map}) {
      console.log(BMap, map);
      var that = this;
      this.center.lng = this.lng;
      this.center.lat = this.lat;
      this.zoom = 15;
      var point = new BMap.Point(this.lng, this.lat);
      map.enableScrollWheelZoom(true);
      map.centerAndZoom(point, 13);
      map.addEventListener("zoomend", function () {
        // alert("地图缩放至：" + this.getZoom() + "级");
        map.panTo(new BMap.Point(that.lng, that.lat));
      });
      window.setTimeout(function () {
        map.panTo(new BMap.Point(that.lng, that.lat));
      }, 2000);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
    getInfo() {
      this.$http
        .get("/hdbs/api/contacts/company")
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0 && response.data.data.length == 1) {
              this.data = response.data.data[0];
              // this.bannertext = this.language == 'zh'?this.zzry[0].key:this.zzry[0].keyEn
            }
          }.bind(this)
        )
    }
  },
};
</script>

<style lang="stylus" scoped>
.bm-view {
  width: 100%;
  height: 400px;
}

.info_div {
  p {
    margin-bottom: 0;
  }

  .title {
    color: var(--mainBlue);
    font-size: 2.7rem;
    font-family: Demibold;
  }
}

.margin_top {
  margin-top: 2rem;
}

.infoBtn {
  // position: absolute;
  margin-top: 5rem;
  font-size: 2.1rem;
  width: auto;
  height: 5rem;
  font-family: Regular;
  animation: myBreath 1.5s linear infinite;
}

@keyframes myBreath {
  0% {
    transform: scale(1.18);
  }
  50% {
    transform: scale(100%);
  }
  100% {
    transform: scale(1.18);
  }
}

.flex_div {
  display: flex;
  margin-top: 3rem;

  .img_div {
    cursor: pointer;
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem 4rem 1rem 0;
    text-align: center;
    overflow: hidden;

    img {
      width: auto;
      height: 3rem;
      margin-bottom: 1rem;
      transform: translateY(-60px);
      filter: drop-shadow(0 60px 0 #727171);

    }

    &:hover {
      img {
        filter: drop-shadow(0 60px 0 #024580);
      }

    }
  }
}

.img_div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;

  img {
    width: 15rem;
    height: auto;

  }

  p {
    text-align: center
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CallUs/Map.vue